import { useState, type ReactNode } from "react";

export function CollapsibleSection({
  title,
  summary,
  defaultOpen = false,
  children,
}: {
  title: string;
  summary?: string;
  defaultOpen?: boolean;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="support-collapse">
      <button type="button" className="support-collapse__trigger" onClick={() => setOpen((v) => !v)}>
        <span className="support-collapse__chevron" aria-hidden>{open ? "▼" : "▶"}</span>
        <span className="support-collapse__title">{title}</span>
        {!open && summary ? <span className="support-collapse__summary">{summary}</span> : null}
      </button>
      {open ? <div className="support-collapse__body">{children}</div> : null}
    </div>
  );
}
